var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.DockerNetwork", function(octopusRepository, octopusFeatures) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canHaveChildren: false,
            canBeChild: false,
            canChooseRoles: true,
            canShow: function() { return octopusFeatures.isEnabled('IsDockerEnabled'); },
            hasPackages: function(action) { return false; },
            summaryTemplateUrl: "areas/projects/actions/docker_network/Octopus.DockerNetwork_summary.html",
            editTemplateUrl: "areas/projects/actions/docker_network/Octopus.DockerNetwork_edit.html",
            preLink: function(vm) {
                vm.networkTypes = {
                    "bridge": {
                        name: "Bridge (Default)",
                        description: "Connect the container to the bridge via veth interfaces."
                    },
                    "other": {
                        name: "Custom",
                        description: "Use an installed third party or own custom network driver."
                    }
                };

                if (!vm.action.Properties["Octopus.Action.Docker.NetworkType"]) {
                    vm.action.Properties["Octopus.Action.Docker.NetworkType"] = "bridge";
                }
            },
            summaryLink: function($scope, element) {
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_network/Octopus.DockerNetwork.js
// module id = 494
// module chunks = 1